import { useState } from 'react';

export default function useText() {
  const [state, setState] = useState('');

  return { state, setState };
}
